import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { getAuthCookie } from "../../utils/authCookies";
import { useModuleActionPermissions } from "hooks/useModuleActionPermissions";
import { MODULE_PERMISSION_NAMES } from "utils/moduleActionPermissions";
import { formatPaymentMethodLabel } from "../../utils/paymentMethodLabel";
// import "../../../node_modules/datatables.net-dt/css/jquery.dataTables.min.css";
// import "../../../node_modules/datatables.net-responsive-dt/css/responsive.dataTables.min.css";
import $ from "jquery";
import "datatables.net";
import "datatables.net-responsive";
import { showSuccess, showError } from "toast/toast";
import DataTable from "components/DataTable";
import PaginationControls from "components/PaginationControls";
import React, { useEffect, useMemo, useState, useRef, KeyboardEvent, ChangeEvent } from "react";
import Select, { components } from "react-select";
import { RemovalStatusBadge } from "components/Removalstatus";
import { StatusBadge } from "components/Productlocationstatus";
import TablePaginationControls from "components/TableandmobilePaginationcontrol"
import { DesktopTableParts, MobileCardsOnly } from "components/TableandMobilecomponent";
import { ViewIconButton, EditIconButton, DeleteIconButton } from "components/DatatablesActionIcons";
import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  flexRender,
  createColumnHelper,
} from "@tanstack/react-table";

import {
  ExportAsExcel,
} from "@siamf/react-export";

const DATE_OPTIONS = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Last 15 Days", value: "last_15_days" },
  { label: "Last 30 Days", value: "last_30_days" },
  { label: "Custom", value: "custom" },
];

const ORDER_STATUS_OPTIONS = [
  { value: "", label: "Order Status" },
  { value: "100", label: "Draft" },
  { value: "200", label: "Finalized" },
  { value: "300", label: "Scheduled" },
  { value: "400", label: "In Progress" },
  { value: "500", label: "Completed" },
  { value: "600", label: "Closed" },
  { value: "700", label: "Cancelled" },
  { value: "800", label: "Void" }
];

const PAYMENT_STATUS_OPTIONS = [
  { value: "", label: "Payment Status" },
  { value: "Paid", label: "Paid" },
  { value: "Partial Payment", label: "Partial Payment" },
  { value: "Pending", label: "Pending" },
  { value: "Overdue", label: "Overdue" }
];

const PRIORITY_OPTIONS = [
  { value: "", label: "Priority" },
  { value: "1", label: "High" },
  { value: "2", label: "Medium" },
  { value: "3", label: "Low" }
];

type Category = {
  id: string;
  name: string;
  image: string;
  status: string;
};

export type RemovalOrders = {
  _id: string;                     // Unique id (map from order_id)
  order_id: string;                // Order ID from API
  created_date: string;            // Created date
  brokerage_firm: string;
  office: string;
  agent: string;
  installer: string;
  installation_date: string;
  payment_status: string;
  payment_method: string;
  status: number;
  product_location_status: string;
  priority: number;
};
const PRIORITY_LABELS: { [key: number]: string } = {
  1: "High",
  2: "Medium",
  3: "Low",
};

const DropdownIndicator = (props: any) => {
  if (props.selectProps.isDisabled) return null;
  return (
    <components.DropdownIndicator {...props}>
      <i className="ri-arrow-down-s-line fs-5" style={{ color: "#6c757d" }} />
    </components.DropdownIndicator>
  );
};

const customSelectStyles = {
  indicatorsContainer: (p: any, s: any) => ({ ...p, display: s.isDisabled ? "none" : "flex" }),
  dropdownIndicator: (p: any, s: any) => ({ ...p, display: s.isDisabled ? "none" : "flex" }),
  indicatorSeparator: () => ({ display: "none" }),
  control: (p: any, s: any) => ({
    ...p,
    backgroundColor: s.isDisabled ? "#f2f2f2" : p.backgroundColor,
    cursor: s.isDisabled ? "not-allowed" : "pointer",
    opacity: 1,
  }),
  singleValue: (p: any, s: any) => ({ ...p, color: s.isDisabled ? "#000" : p.color }),
  valueContainer: (p: any, s: any) => ({ ...p, color: s.isDisabled ? "#000" : p.color }),
  input: (p: any, s: any) => ({ ...p, color: s.isDisabled ? "#000" : p.color, WebkitTextFillColor: s.isDisabled ? "#000" : undefined }),
  placeholder: (p: any, s: any) => ({ ...p, color: s.isDisabled ? "#000" : p.color }),
  menu: (provided: any) => ({ ...provided, zIndex: 9999, position: "absolute", top: "100%", left: 0, right: 0 }),
  menuList: (provided: any) => ({ ...provided, maxHeight: "220px" }),
};

const columnHelper = createColumnHelper<RemovalOrders>();
const RealtorRemovalRequests = () => {
  const [removalRequests, setRemovalRequests] = useState<any[]>([]);
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState<string | null>(null);
  const [removal, setRemoval] = useState<RemovalOrders[]>([]);
  const [filteredremoval, setFilteredRemoval] = useState<RemovalOrders[]>([]);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [rowCount, setRowCount] = useState(0);
  const [globalFilter, setGlobalFilter] = useState("");
  const [searchInput, setSearchInput] = useState<string>(globalFilter ?? "");
  const searchInputRef = useRef<HTMLInputElement>(null);
  const token = getAuthCookie("sessionToken");
  const userId = getAuthCookie("userId");
  const userName = getAuthCookie("userName");
  const location = useLocation();
  const isTeammember = location.pathname.includes('/teammember');
  const baseRoute = isTeammember ? '/teammember' : '/realtor';
  const { canCreate, canView, canEdit, canDelete } = useModuleActionPermissions(
    MODULE_PERMISSION_NAMES.removal_orders
  );
  const navigate = useNavigate();

  function getRemovalRowId(order: RemovalOrders): string {
    return String((order as any)?._id ?? (order as any)?.id ?? (order as any)?.order_id ?? "");
  }

  const [filtersOpen, setFiltersOpen] = useState(false);
  const [datePreset, setDatePreset] = useState<(typeof DATE_OPTIONS)[number] | null>(null);
  const [customFrom, setCustomFrom] = useState("");
  const [customTo, setCustomTo] = useState("");

  const { minDate, maxDate } = useMemo(() => {
    const now = new Date();
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(now.getMonth() - 6);
    return {
      minDate: sixMonthsAgo.toISOString().split("T")[0],
      maxDate: now.toISOString().split("T")[0],
    };
  }, []);

  useEffect(() => {
    if (datePreset?.value === "custom") {
      if (customFrom && (customFrom < minDate || customFrom > maxDate)) setCustomFrom("");
      if (customTo && (customTo < minDate || customTo > maxDate)) setCustomTo("");
    }
  }, [datePreset?.value, minDate, maxDate]);

  const [orderStatusFilter, setOrderStatusFilter] = useState(ORDER_STATUS_OPTIONS[0]);
  const [paymentStatusFilter, setPaymentStatusFilter] = useState(PAYMENT_STATUS_OPTIONS[0]);
  const [priorityFilter, setPriorityFilter] = useState(PRIORITY_OPTIONS[0]);

  // useEffect(() => {
  //   const fetchRemovalRequests = async () => {
  //     try {
  //       const response = await fetch(
  //         `${process.env.REACT_APP_API_URL}/removal_orders/created_by`,
  //         {
  //           method: "GET",
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );
  //       const data = await response.json();

  //       if (!response.ok) {
  //         showError(data?.error || "Failed to fetch removal requests.");
  //         return;
  //       }

  //       setRemovalRequests(Array.isArray(data) ? data : []);
  //     } catch (err) {
  //       showError(
  //         err instanceof Error ? err.message : "An unknown error occurred."
  //       );
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchRemovalRequests();
  // }, []);

  // useEffect(() => {
  //   // Initialize DataTable when categories change
  //   const table = $("#categoriesTable").DataTable({
  //     responsive: true,
  //     destroy: true, // Ensure DataTable re-initializes properly
  //     // columnDefs: [
  //     //   { orderable: false, targets: [0, 4] }, // Disable sorting for specific columns
  //     // ],
  //     lengthChange: false,
  //     ordering: false,
  //   });

  //   return () => {
  //     table.destroy(); // Clean up on component unmount
  //   };
  // }, [removalRequests]);

  useEffect(() => {
    const fetchAgents = async () => {
      // Only show loading on initial load, not during search
      if (pagination.pageIndex === 0 && !globalFilter) {
        setLoading(true);
      }
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/removal_orders/created_by/datatable`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              page: pagination.pageIndex + 1,
              limit: pagination.pageSize,
              search: globalFilter,
              status: orderStatusFilter.value ? [Number(orderStatusFilter.value)] : undefined,
              payment_status: paymentStatusFilter.value || undefined,
              priority: priorityFilter.value ? [Number(priorityFilter.value)] : undefined,
              agent_id: null,
              office_id: null,
              date_range: {
                type: datePreset?.value ?? "",
                from: datePreset?.value === "custom" ? customFrom : "",
                to: datePreset?.value === "custom" ? customTo : "",
              },
              sort_by: "created_at",
              sort_dir: "desc",
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch agents");
        }

        const result = await response.json();
        console.log(result, "result");
        setRowCount(result.total);

        const removal = result?.data ?? [];
        console.log("removal", result);
        if (Array.isArray(removal)) {
          setRemoval(removal);
          setFilteredRemoval(removal);
        } else {
          throw new Error("Unexpected response format for agents");
        }

      } catch (err) {
        setError(
          err instanceof Error ? err.message : "An unknown error occurred"
        );
      } finally {
        setLoading(false);
        // Maintain cursor focus in search input after loading
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
      }
    };

    fetchAgents();
  }, [token, userId, globalFilter, pagination, deleting]);

  const handleDelete = async (orderId: string) => {
    setDeleting(orderId);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/removal_orders/${orderId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok) {
        showError(data?.error || "Failed to delete removal request.");
        return;
      }

      showSuccess("Removal request deleted successfully!");
      setRemovalRequests((prev) => prev.filter((order) => order._id !== orderId));
    } catch (err) {
      showError(
        err instanceof Error ? err.message : "An unknown error occurred."
      );
    } finally {
      setDeleting(null);
    }
  };



  const columns = useMemo(() => [
    columnHelper.accessor("order_id", {
      id: "order_number",
      header: () => <div className="th-text S-No">Order ID</div>,
      cell: (info) => {
        const row = info.row.original;
        // pick whichever your data uses:
        const orderId =
          (row as any).id ?? (row as any)._id ?? (row as any).order_id;

        return (
          <Link
          to={`${baseRoute}/jobs/editRemovalRequest/${orderId}`} state={{ type: "View" }}
            className="text-sm S-No order-link-1"
          >
            {info.getValue() ?? ""}
          </Link>
        );
      },
      // filterFn: fuzzyTextFilter,
      enableGlobalFilter: true,
    }),
    // columnHelper.display({
    //   id: "serial",
    //   header: () => <div className="th-text S-No">S.No.</div>,
    //   cell: (info) => (
    //     <div className="text-sm S-No">
    //       {pagination.pageIndex * pagination.pageSize + info.row.index + 1}
    //     </div>
    //   ),
    // }),
    // columnHelper.accessor("order_id", {
    //   header: () => <div className="th-text S-No">Order ID</div>,
    //   cell: (info) => <div className="text-sm order-link-1 S-No">{info.getValue()}</div>,
    // }),
    columnHelper.accessor("created_date", {
      header: () => <div className="th-text">Created Date</div>,
      cell: (info) => (
        <div className="text-sm">
          {info.getValue() ? new Date(info.getValue()).toLocaleDateString() : "—"}
        </div>
      ),
    }),
    columnHelper.accessor("brokerage_firm", {
      header: () => <div className="th-text">Brokerage firm</div>,
      cell: (info) => <div className="text-sm">{info.getValue() || "—"}</div>,
    }),
    columnHelper.accessor("office", {
      header: () => <div className="th-text">Office</div>,
      cell: (info) => <div className="text-sm">{info.getValue() || "—"}</div>,
    }),
    columnHelper.accessor("agent", {
      header: () => <div className="th-text">Agent</div>,
      cell: (info) => <div className="text-sm">{info.getValue() || "—"}</div>,
    }),
    columnHelper.accessor("installer", {
      header: () => <div className="th-text">Installer</div>,
      cell: (info) => <div className="text-sm">{info.getValue() || "—"}</div>,
    }),
    columnHelper.accessor("installation_date", {
      header: () => <div className="th-text">Installation Date</div>,
      cell: (info) => (
        <div className="text-sm">
          {info.getValue() ? new Date(info.getValue()).toLocaleDateString() : "—"}
        </div>
      ),
    }),
    columnHelper.accessor("payment_status", {
      header: () => <div className="th-text">Payment Status</div>,
      cell: info => (
        <div className="text-sm">
          <RemovalStatusBadge value={info.getValue() as string} type="payment" />
        </div>
      ),
    }),
    columnHelper.accessor(
      (row) => formatPaymentMethodLabel(row.payment_method),
      {
        id: "payment_method",
        header: () => <div className="th-text">Payment Method</div>,
        cell: info => <div className="text-sm">{info.getValue()}</div>,
        enableGlobalFilter: true,
      }
    ),

    // Order Status column
    columnHelper.accessor("status", {
      header: () => <div className="th-text">Status</div>,
      cell: info => (
        <div className="text-sm">
          <RemovalStatusBadge value={info.getValue() as number} type="order" />
        </div>
      ),
    }),
    columnHelper.accessor("product_location_status", {
      header: () => <div className="th-text">	Handover Method</div>,
      cell: (info) => <div className=""><StatusBadge status={info.getValue()|| "-"} /></div>,
    }),
    columnHelper.accessor("priority", {
      header: () => <div className="th-text">Priority</div>,
      cell: (info) => {
        const val = info.getValue() as number | undefined | null;
        const label = val ? PRIORITY_LABELS[val] : undefined;

        // Render badge component with label (or fallback)
        return (
          <div className="text-sm">
            {label ? (
              <RemovalStatusBadge value={label} type="priority" />
            ) : (
              "—"
            )}
          </div>
        );
      },
    }),
    // columnHelper.accessor("payment_status", {
    //   header: () => <div className="th-text">Payment Status</div>,
    //   cell: (info) => <div className="text-sm">{info.getValue() || "—"}</div>,
    // }),
    // columnHelper.accessor("status", {
    //   header: () => <div className="th-text">Status</div>,
    //   cell: (info) => {
    //     const status = info.getValue();
    //     const label =
    //       status === 100 ? "Draft" :
    //         status === 200 ? "Finalized" :
    //           status === 300 ? "Scheduled" :
    //             status === 400 ? "In Progress" :
    //               status === 500 ? "Completed" :
    //                 status === 600 ? "Canceled" : "Unknown";
    //     return <div className="text-sm">{label}</div>;
    //   },
    // }),
    // columnHelper.accessor("product_location_status", {
    //   header: () => <div className="th-text">Product location status</div>,
    //   cell: (info) => <div className="text-sm">{info.getValue() || "—"}</div>,
    // }),
    // columnHelper.accessor("priority", {
    //   header: () => <div className="th-text">Priority</div>,
    //   cell: (info) => <div className="text-sm">{info.getValue() || "—"}</div>,
    // }),
    columnHelper.display({
      id: "actions",
      header: () => <div className="th-text">Actions</div>,
      cell: (info) => {
        const order = info.row.original;
        if (!canView && !canEdit && !canDelete) return null;
        return (
          <div className="d-flex  align-items-center gap-2">
            {canView && (
              <ViewIconButton
                className="btn action-btn fs-2 text-center"
                to={`${baseRoute}/jobs/editRemovalRequest/${info.row.original._id}`} state={{ type: "View" }}
                title="View"
              />
            )}
            {canEdit && order.status < 200 &&
              <EditIconButton
                className="icon-square me-3"
                to={`${baseRoute}/jobs/editRemovalRequest/${info.row.original._id}`} state={{ type: "Edit" }}
              />

            }
          </div>
        )
      },
    }),
  ], [pagination, canView, canEdit, canDelete]);
  const table = useReactTable({
    data: removal,
    columns,
    pageCount: Math.ceil(rowCount / pagination.pageSize), // Or whatever total count if server-side
    state: {
      pagination,
      // Add globalFilter if needed
    },
    manualPagination: true,
    getCoreRowModel: getCoreRowModel(),
    onPaginationChange: setPagination,
  });

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="content">
      <div className="d-flex justify-content-between align-items-center pb-3 mb-2 py-3">
        <h4 className="mb-0 fw-bold"></h4>
        <div className="d-flex gap-3 align-items-center">
          {canCreate && (
            <Link to={`${baseRoute}/jobs/addRemovalRequest`} className="btn btn-primary  table-addbutton">
              + Add Removal
            </Link>
          )}
        </div>
      </div>
      <div className="po-header mb-4">
        {/* TOP ROW */}
        <div className="po-top d-flex justify-content-between align-items-start align-items-md-center flex-wrap gap-2">
          <div className="po-title-wrap me-2">
            <h4 className="mb-1 po-title">Removal Requests</h4>
          </div>
          <div className="po-tools d-flex align-items-center flex-wrap gap-2 ms-auto">
            <div className="input-group po-search ">
              <span className="input-group-text">
                <i className="ri-search-line" />
              </span>
              <input
                ref={searchInputRef}
                type="text"
                id="searchInput"
                name="searchInput"
                className="form-control"
                placeholder="Search by Product Name, SKU, Brokerages…"
                value={searchInput}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setSearchInput(e.target.value)}
                onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
                  if (e.key === "Enter") {
                    setPagination((prev) => ({ ...prev, pageIndex: 0 })); // :white_check_mark: Reset to page 1
                    setGlobalFilter(searchInput);
                  }
                }}
              />
            </div>
            
            {/* Filters toggle */}
            <button
              type="button"
              className={` po-filter-btn d-inline-flex align-items-center ${filtersOpen ? "active" : ""}`}
              onClick={() => setFiltersOpen(v => !v)}
              aria-expanded={filtersOpen}
              aria-controls="incoming-filters"
            >
              <i className="ri-filter-3-line me-2" />
              <span>Filters</span>
              <i className={`ri-arrow-down-s-line ms-1 ${filtersOpen ? "rotate-180" : ""}`} />
            </button>

            {/* Export */}
            <ExportAsExcel
              data={removal}
              headers={[
                "Order ID",
                "Created Date",
                "Brokerage Firm",
                "Office",
                "Agent",
                "Installer",
                "Installation Date",
                "Payment Status",
                "Status",
                "Handover Method",
                "Priority"
              ]}
              fileName="RemovalRequests"
            >
              {(props) => (
                <button {...props} className="export-button">
                  <i className="ri-file-excel-2-line me-2" />
                  Export to Excel
                </button>
              )}
            </ExportAsExcel>
          </div>
        </div>

        <div id="incoming-filters" className={`po-filters ${filtersOpen ? "show" : ""}`}>
          <div className="po-filters-bar d-flex">
            <div className="row g-2 g-md-3 align-items-end justify-content-md-end ms-md-auto w-100 w-md-auto">

              {/* Date Range */}
              <div className="col-12 col-md-auto">
                <label className="form-label mb-1 label-1">Date Range</label>
                <div className="po-rs min-220">
                  <Select
                    classNamePrefix="rs"
                    options={DATE_OPTIONS}
                    value={datePreset}
                    onChange={(val) => setDatePreset(val ?? null)}
                    placeholder="Select date range"
                    isClearable
                    components={{ DropdownIndicator }}
                    styles={customSelectStyles}
                  />
                </div>

                {datePreset?.value === "custom" && (
                  <div className="d-flex flex-wrap gap-2 mt-2">
                    <div className="flex-fill">
                      <label className="form-label mb-1 label-1">From</label>
                      <input
                        type="date"
                        className="form-control"
                        min={minDate}
                        max={maxDate}
                        value={customFrom}
                        onChange={(e) => setCustomFrom(e.target.value)}
                      />
                    </div>
                    <div className="flex-fill">
                      <label className="form-label mb-1 label-1">To</label>
                      <input
                        type="date"
                        className="form-control"
                        min={minDate}
                        max={maxDate}
                        value={customTo}
                        onChange={(e) => setCustomTo(e.target.value)}
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* Order Status */}
              <div className="col-12 col-lg-auto">
                <label className="form-label mb-1 label-1">Order Status</label>
                <div className="po-rs min-220">
                  <Select
                    classNamePrefix="rs"
                    options={ORDER_STATUS_OPTIONS}
                    value={orderStatusFilter}
                    onChange={(option) => option && setOrderStatusFilter(option)}
                    isSearchable
                    components={{ DropdownIndicator }}
                    styles={customSelectStyles}
                  />
                </div>
              </div>

              {/* Payment Status */}
              <div className="col-12 col-lg-auto">
                <label className="form-label mb-1 label-1">Payment Status</label>
                <div className="po-rs min-220">
                  <Select
                    classNamePrefix="rs"
                    options={PAYMENT_STATUS_OPTIONS}
                    value={paymentStatusFilter}
                    onChange={(option) => option && setPaymentStatusFilter(option)}
                    isSearchable
                    components={{ DropdownIndicator }}
                    styles={customSelectStyles}
                  />
                </div>
              </div>

              {/* Priority */}
              <div className="col-12 col-md-auto">
                <label className="form-label mb-1 label-1">Priority</label>
                <div className="po-rs min-220">
                  <Select
                    classNamePrefix="rs"
                    options={PRIORITY_OPTIONS}
                    value={priorityFilter}
                    onChange={(option) => option && setPriorityFilter(option)}
                    isSearchable
                    components={{ DropdownIndicator }}
                    styles={customSelectStyles}
                  />
                </div>
              </div>

              {/* Actions */}
              <div className="col-12 col-md-auto d-flex justify-content-md-end gap-2 mt-1 mt-md-0">
                <button className="btn btn-primary table-addbutton flex-fill flex-lg-grow-0 br-8" onClick={() => {
                  setPagination({ ...pagination, pageIndex: 0 });
                }}>
                  Apply Filters
                </button>

                <button
                  className="btn back-btn surface-btn fw-bold fs-16 flex-fill flex-lg-grow-0"
                  onClick={() => {
                    // Reset all filters to default values
                    setDatePreset(null);
                    setCustomFrom("");
                    setCustomTo("");
                    setOrderStatusFilter(ORDER_STATUS_OPTIONS[0]); // "Order Status" (default)
                    setPaymentStatusFilter(PAYMENT_STATUS_OPTIONS[0]); // "Payment Status" (default)
                    setPriorityFilter(PRIORITY_OPTIONS[0]); // "Priority" (default)
                    setGlobalFilter(""); // Clear search
                    setSearchInput(""); // Clear search input
                    setPagination({ pageIndex: 0, pageSize: 10 }); // Reset to first page
                  }}
                >
                  Clear
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div className="card overflow-hidden production-card box-shadow-datatables shadow-border-datatables">
        {/* Header like screenshot (left title, right count pill) */}
        <div className="align-items-center bg-white border-bottom d-flex justify-content-between px-4 py-4">
          <h5 className="mb-0 ">Removals</h5>
          <span className="badge rounded-pill bg-body-tertiary text-secondary-emphasis px-3 py-2">
            {/* orders */}
          </span>
        </div>
        <hr className="mb-2" style={{ borderTop: "none" }} />


        {/* DESKTOP/TABLET */}
        <div className="rdt-desktop">
          <div
            className="production-scroll"
            style={{ "--rdt-min": "1200px" } as React.CSSProperties}
          >
            <table className="table production-table align-middle mb-0 table-1">
              <DesktopTableParts
                table={table}
                onRowClick={(row) => {
                  const id = getRemovalRowId(row);
                  if (!id) return;
                  navigate(`${baseRoute}/jobs/editRemovalRequest/${id}`, { state: { type: "View" } });
                }}
              />
            </table>
          </div>
        </div>

        {/* MOBILE (≤ 1021px) */}
        <div className="rdt-mobile">
          <MobileCardsOnly
            table={table}
            idColId="order_link"
            titleColId="product_name"
            actionColId="actions"
            onRowClick={(row) => {
              const id = getRemovalRowId(row);
              if (!id) return;
              navigate(`${baseRoute}/jobs/editRemovalRequest/${id}`, { state: { type: "View" } });
            }}
          />
        </div>

      </div>
      {table.getRowModel().rows.length === 0 ? (
        <div className="text-center my-4 text-muted" style={{ fontSize: "1.1rem" }}>
          No records found
        </div>
      ) : (
        <div className="mt-4 mb-4">
          <TablePaginationControls table={table} />
        </div>
      )}
    </div>
  );
};

export default RealtorRemovalRequests;


{/* <div className="content">
      <div className="card">
        <div className="card-body">
          <h2>Removal Requests </h2>
          <div className="text-end">
            <Link
              to={`${baseRoute}/jobs/addRemovalRequest`}
              className="btn btn-primary float-right"
            >
              Add Removal Request
            </Link>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-12 col-xl-12">
              <div className="card mt-4 card-bg-fill">
                <div className="card-body p-4">
                  <div className="table-container">
                    <table
                      id="categoriesTable"
                      className="table table-bordered dt-responsive nowrap table-striped align-middle w-100"
                    >
                      <thead>
                        <tr>
                          <th>S.No.</th>
                          <th>Order ID</th>
                          <th>Product</th>
                          <th>Date</th>
                          <th>Billing Address</th>
                          <th>Removal Address</th>
                          <th>Removal Date</th>
                          <th>Payment Status</th>
                          <th>Order Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(removalRequests) && removalRequests.map((order, index) => (
                          <tr key={order._id}>
                            <td>{index + 1}</td>
                            <td>{order.order_number}</td>
                            <td>
                              {Array.isArray(order.line_items) && order.line_items.length > 0
                                ? order.line_items
                                  .filter((item: any) => !!item.product_name)
                                  .map((item: any) => item.product_name.trim())
                                  .join(", ")
                                : "—"}

                            </td>

                            <td>{order.created_at ? new Date(order.created_at).toLocaleDateString() : "—"}</td>
                            <td>{order.billing_address?.addressLine1 || "—"}</td>
                            <td>{order.removal_details?.removal_address?.addressLine1 || "—"}</td>
                            <td>
                              {order.removal_details?.scheduled_date
                                ? new Date(order.removal_details.scheduled_date).toLocaleDateString()
                                : "—"}
                            </td>
                            <td>{order.payment_status || "—"}</td>
                            <td>
                              {order?.status === 100 ? "Draft" :
                                order?.status === 200 ? "Finalized" :
                                  order?.status === 300 ? "Scheduled" :
                                    order?.status === 400 ? "In Progress" :
                                      order?.status === 500 ? "Completed" :
                                        order?.status === 600 ? "Canceled" :
                                          "Unknown"}
                            </td>
                            <td>
                              <Link className="btn btn-info btn-sm me-2" to={`${baseRoute}/jobs/viewRemovalRequest/${order._id}`}>
                                View
                              </Link>
                              <Link className="btn btn-warning btn-sm" to={`${baseRoute}/jobs/editRemovalRequest/${order._id}`}>
                                Edit
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> */}